import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=c510ed54&scoped=true&"
import script from "./PageLoader.vue?vue&type=script&lang=js&"
export * from "./PageLoader.vue?vue&type=script&lang=js&"
import style0 from "./PageLoader.vue?vue&type=style&index=0&id=c510ed54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c510ed54",
  null
  
)

export default component.exports